"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var IFilterClause_1 = require("@tableau/vizportal-webclient-api/lib/api/types/IFilterClause");
// For reference, GetUsers request needs Filter which is an array of FilterClauses.
// ICompositeFilterClause = IFilterClause + ILeafFilterClause[];
var defaultOperatorType = IFilterClause_1.FilterOps.and;
function getFilterParams(filterClauses, operatorType) {
    if (operatorType === void 0) { operatorType = defaultOperatorType; }
    return {
        operator: operatorType,
        clauses: filterClauses
    };
}
function getFilterClauseParams(operatorType, value) {
    return {
        operator: operatorType,
        value: value
    };
}
function getSearchUserNameFilterParams(nameQueryText) {
    var filterClauseParams = getFilterClauseParams(IFilterClause_1.FilterOps.matches, nameQueryText || '');
    return getFilterParams([filterClauseParams]);
}
exports.getSearchUserNameFilterParams = getSearchUserNameFilterParams;
//# sourceMappingURL=FilterParams.js.map